export type GroceryMasterRow = {
  code: string;
  name: string;
  metadata?: Record<string, unknown>;
};

export function groceryMasterImageUrl(row?: GroceryMasterRow | null): string {
  if (!row?.metadata) return '';
  return String(row.metadata.imageUrl || row.metadata.logoUrl || '');
}

export function findGroceryProductImage(
  images: GroceryMasterRow[],
  skuCode: string,
  imageType: 'thumbnail' | 'gallery' = 'thumbnail',
): string {
  const match = images.find((row) => {
    const meta = row.metadata || {};
    return String(meta.skuCode || '').toUpperCase() === skuCode.toUpperCase()
      && String(meta.imageType || 'thumbnail') === imageType;
  });
  return groceryMasterImageUrl(match);
}

export function resolveGroceryThumbnailFromMasters(opts: {
  skuCode?: string;
  categoryCode?: string;
  brandCode?: string;
  productImages?: GroceryMasterRow[];
  categories?: GroceryMasterRow[];
  brands?: GroceryMasterRow[];
}): string {
  const { skuCode, categoryCode, brandCode, productImages = [], categories = [], brands = [] } = opts;
  if (skuCode) {
    const fromSku = findGroceryProductImage(productImages, skuCode, 'thumbnail');
    if (fromSku) return fromSku;
  }
  if (categoryCode) {
    const cat = categories.find((c) => c.code === categoryCode);
    const url = groceryMasterImageUrl(cat);
    if (url) return url;
  }
  if (brandCode) {
    return groceryMasterImageUrl(brands.find((b) => b.code === brandCode));
  }
  return '';
}

export type StoreHourRow = { day: string; openTime: string; closeTime: string; isClosed?: boolean };

export const GROCERY_WEEK_DAYS = [
  { value: 'mon', label: 'Mon' }, { value: 'tue', label: 'Tue' }, { value: 'wed', label: 'Wed' },
  { value: 'thu', label: 'Thu' }, { value: 'fri', label: 'Fri' }, { value: 'sat', label: 'Sat' },
  { value: 'sun', label: 'Sun' },
];

export function defaultStoreHours(): StoreHourRow[] {
  return GROCERY_WEEK_DAYS.map((d) => ({ day: d.value, openTime: '07:00', closeTime: '22:00', isClosed: false }));
}

export function storeHoursFromMasters(templates: GroceryMasterRow[]): StoreHourRow[] {
  const byDay: Record<string, StoreHourRow> = {};
  for (const row of templates) {
    const meta = row.metadata || {};
    const day = String(meta.day || '');
    if (!day) continue;
    byDay[day] = {
      day,
      openTime: String(meta.startTime || meta.openTime || '07:00'),
      closeTime: String(meta.endTime || meta.closeTime || '22:00'),
      isClosed: Boolean(meta.isClosed),
    };
  }
  return GROCERY_WEEK_DAYS.map((d) => byDay[d.value] || { day: d.value, openTime: '07:00', closeTime: '22:00', isClosed: false });
}

export function resolveStoreLogoFromMasters(storeTypeCode: string, storeTypes: GroceryMasterRow[]): string {
  return groceryMasterImageUrl(storeTypes.find((t) => t.code === storeTypeCode));
}
